import React from 'react';
import { Spin } from 'antd';

const LoadingIndicator: React.FC = () => {
  return (
    <div className='loading-indicator'>
      <Spin size='large' />
    </div>
  );
};

export default LoadingIndicator;
